import 'moment/locale/id';
import * as ExcelJS from 'exceljs';
import moment from 'moment';
import 'moment-duration-format';
import { UserModel } from '../../app/modules/auth/models/UserModel';
import { CustomField } from '../../interfaces/Settings';
import { exportWorkbook, setColumnWidths, styleColumns, addWorkSheetInfo, createSingleOptionWorksheets, addNumberFormatting } from './helperTemplateExcel';
import { createWorkbook } from './helperTemplateExcel';
import { createWorksheet } from './helperTemplateExcel';
import { User } from '../../interfaces/User';
import { MultiSimpleMerchant, SimpleMerchant } from '../../interfaces/Merchant';
import { MultiSimpleMeeting, SimpleMeeting } from '../../interfaces/Meeting';
import { MultiSimplePipeline, SimplePipeline } from '../../interfaces/Pipeline';
import { addSingleOptionValidation } from './functionHelperExcel';

interface ExportTemplatePipelineExcelProps {
    nameFile: string,
    customFields: CustomField,
    source: string,
    typeAction: string,
    settings: any,
    nameInfo: string,
    nameHeader: any,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    simpleCustomFieldsMaster: {
        pipelines: MultiSimplePipeline
        meetings: MultiSimpleMeeting
        merchants: MultiSimpleMerchant
        users: Record<string, User[]>;
    },
    user: UserModel,
    param: any,
    dataMerchants: SimpleMerchant[],
    intl: any,
    type?: string,
}

export const exportTemplatePipelineExcel = async ({ nameFile, customFields, source, typeAction, settings, nameInfo, nameHeader, setIsLoading, simpleCustomFieldsMaster, user, param, type, dataMerchants, intl }: ExportTemplatePipelineExcelProps) => {
    let exportData: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, "Sheet1");
    const worksheetInfo = createWorksheet(workbook, "Info");
    var header: string[] = []
    var subHeader: string[] = []
    let singleOptionSheetsPipelines = {};

    header = [...nameHeader.insert.pipeline.header];
    subHeader = [...nameHeader.insert.pipeline.subHeader];

    let worksheetUser = workbook.addWorksheet('Daftar User');
    await worksheetUser.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetUser.getCell('A1').value = `Daftar User`;
    await param.dataUsers.forEach((user: any) => {
        worksheetUser.addRow([user.name]);
    });

    let worksheetMerchants = workbook.addWorksheet('Daftar Merchants');
    await worksheetMerchants.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetMerchants.getCell('A1').value = `Daftar Merchants`;
    dataMerchants.forEach((user: any) => {
        worksheetMerchants.addRow([user.name]);
    });

    let worksheetProducts = workbook.addWorksheet('Daftar Produk');
    await worksheetProducts.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetProducts.getCell('A1').value = `Daftar Produk`;
    await param.dataProducts.forEach((user: any) => {
        worksheetProducts.addRow([user.name]);
    });

    let worksheetProgress = workbook.addWorksheet('Daftar Progress');
    await worksheetProgress.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetProgress.getCell('A1').value = `Daftar Progress`;
    await param.dataProgress.forEach((user: any) => {
        worksheetProgress.addRow([user.name]);
    });

    let worksheetSource = workbook.addWorksheet('Daftar Source');
    await worksheetSource.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetSource.getCell('A1').value = `Daftar Source`;
    await param.dataSources.forEach((user: any) => {
        worksheetSource.addRow([user.name]);
    });

    // Daftar Single Option
    singleOptionSheetsPipelines = createSingleOptionWorksheets({ customFields, workbook, simpleCustomFieldsMaster, user: user, intl });

    // kalau type nya error akan menambahkan kolom di bawah ini
    if (type === 'error') {
        header.push('Error');
        subHeader.push('Abaikan kolom ini');
        Array.from(param.listErrorInsert).map((row: any, index) => {
            var temp_excel = [];
            temp_excel.push(
                row.pic_name,
                row.merchant_name,
                row.nominal,
                row.product_name,
                row.progress_name,
                row.source_name,
                row.date_start,
                row.date_end,
                row.note,
                ...Object.keys(customFields).map((field: any) => row[field]),
                row.error
            );

            exportData.push(temp_excel);
        });
    }

    worksheet.getRow(1).values = header;
    worksheet.getRow(2).values = subHeader;
    setColumnWidths(worksheet, source, header!, exportData);
    styleColumns(worksheet, source, 1);
    styleColumns(worksheet, source, 2);
    addDataRows(worksheet, exportData, customFields, source, type!, typeAction, user!, dataMerchants, param, singleOptionSheetsPipelines, simpleCustomFieldsMaster);
    addWorkSheetInfo(worksheetInfo, source, nameFile, nameInfo, nameHeader, user!);

    exportWorkbook(workbook, worksheet, source, `${nameFile}.xlsx`, setIsLoading);
};


export const addDataRows = (
    worksheet: ExcelJS.Worksheet,
    data: any[],
    customFields: CustomField,
    source: string,
    type: string,
    typeAction: string,
    user: UserModel,
    dataMerchants: SimpleMerchant[],
    param?: any,
    singleOptionSheets?: any,
    simpleCustomFieldsMaster?: {
        pipelines: MultiSimplePipeline
        meetings: MultiSimpleMeeting
        merchants: MultiSimpleMerchant
    },
) => {
    data.forEach((rowData, index) => {
        worksheet.addRow(rowData);
    });

    for (let i = 3; i < 550; i++) {
        if (typeAction === 'insert') {
            worksheet.getCell('A' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar User'!$A$2:$A$${param.dataUsers.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih user',
            };
            worksheet.getCell('B' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Merchants'!$A$2:$A$${dataMerchants.length + 2}`],
                errorStyle: 'error',
                error: 'Pilih Merchants',
            };
            worksheet.getCell('D' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Produk'!$A$2:$A$${param.dataProducts.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih Produk',
            };
            worksheet.getCell('E' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Progress'!$A$2:$A$${param.dataProgress.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih Progress',
            };
            worksheet.getCell('F' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Source'!$A$2:$A$${param.dataSources.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih Source',
            };


            worksheet.getCell('C' + i).numFmt = user?.data?.companyCurrencyNeedRound ? '#,##0;-#,##0' : '#,##0.##;-#,##0.##';

            addSingleOptionValidation('J', customFields, singleOptionSheets, typeAction, type, param, worksheet, simpleCustomFieldsMaster);
            addNumberFormatting('J', customFields, typeAction, type, param, worksheet);
        }
    }
};